<template>
    <div>
        <vSelect :options="stopOptions" v-model="stop" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';


export default {
    name: "StopSelect",
    components: {
        vSelect
    },
    data() {
        return {
            stop2: this.tunnus,
        } 
    },
    props: {
        value: String
    },
    computed: {
        stopOptions: function() {
            var ret = [];
            if( this.listData ) {
                var stopList = this.listData;
                stopList.sort( (a,b) => (Number(a.sms) > Number(b.sms) ? 1 : (Number(b.sms) > Number(a.sms)) ? -1 : 0));
                for( var a of stopList ) {
                    ret.push({code: a.tunnus, label: a.sms + ' ' + a.nimi})
                }
            }
            return ret;
        },
        stop: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        },
        listData() {
            return this.$store.state.timetable.pysakit.list;
        },     
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
    },
    mounted() {
         if(!this.listData || this.listData.length === 0) 
             this.$store.dispatch('timetable/getPysakkiListData')
    }
}
</script>